export default {
  create: {
    success: '{name}を作成しました。',
    success_simple: '作成しました。',
    error: '{name}を作成に失敗。',
    error_simple: '作成に失敗しました。',
  },
  save: {
    success: '{name}を保存しました。',
    success_simple: '保存しました。',
    error: '{name}の保存に失敗しました。',
    error_simple: '保存に失敗しました。',
  },
  change: {
    success: '{name}を変更しました。',
    success_simple: '変更しました。',
    error: '{name}の変更に失敗しました。',
    error_simple: '変更に失敗しました。',
  },
  update: {
    success: '{name}を更新しました。',
    success_simple: '更新しました。',
    error: '{name}の更新に失敗しました。',
    error_simple: '更新に失敗しました。',
  },
  delete: {
    success: '{name}を削除しました。',
    success_simple: '削除しました。',
    error: '{name}の削除に失敗しました。',
    error_simple: '削除に失敗しました。',
  },
  fetch: {
    success: '{name}を取得しました。',
    success_simple: '取得しました。',
    error: '{name}の取得に失敗しました。',
    error_simple: '取得に失敗しました。',
  },
  register: {
    success: '{name}を登録しました。',
    success_simple: '登録しました。',
    error: '{name}の登録に失敗しました。',
    error_simple: '登録に失敗しました。',
  },
  add: {
    success: '{name}を追加しました。',
    success_simple: '追加しました。',
    error: '{name}の追加に失敗しました。',
    error_simple: '追加に失敗しました。',
  },
  access: {
    success: '{name}にアクセスしました。',
    success_simple: 'アクセスしました。',
    error: '{name}へのアクセスに失敗しました。',
    error_simple: 'アクセスに失敗しました。',
  },
  default: {
    success: '成功しました。',
    error: 'エラーが発生しました。',
  },
};
